import React, { useState, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'

export const isBrowser = () => typeof window !== 'undefined'

export function hasNoData(data) {
  const { isFetching, ...obj } = data
  return Object.entries(obj).length === 0 && obj.constructor === Object
}

export const encodePhone = (phone) =>
  phone ? `${phone.substr(0, 4)}****${phone.substr(phone.length - 2)}` : null

export const encodeEmail = (email) => {
  if (!email) return null
  const atPos = email.indexOf('@')
  const atPart = email.substr(atPos)
  return `${email.substr(
    0,
    Math.min(4, email.length - atPart.length)
  )}**${atPart}`
}

export const capitalizeOnlyFirstLetter = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : null

export const capitalizeEachFirstLetter = (str) => {
  const words = str.split(' ')

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1)
  }
  return words.join(' ')
}

export const toLowerCase = (str) => (str ? str.toLowerCase() : null)

export const formatCurrency = (num,wholeDollarOnly) => {
  if (!num) return '$0'
  if (num === 0) return '$0'
  else
    return num.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: wholeDollarOnly ? 0 : 2 })
}

export const formatNumber = (num) =>
  num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null

export const isDateValid = (date) => {
  return new Date(date) !== 'Invalid Date' &&
    !isNaN(new Date(date)) &&
    new Date(date) > new Date('1901-01-01')
    ? true
    : false
}

export const addDaysToDateInString = (date, noOfDays) => {
  var month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  let _date = new Date(date)
  _date.setDate(_date.getDate() + noOfDays)
  return (
    _date.getDate() + ' ' + month[_date.getMonth()] + ' ' + _date.getFullYear()
  )
}

export const addHoursToCurrentDate = (noOfHours) => {
  let _date = new Date()
  // seconds * minutes * hours * milliseconds = 1 day
  let additionalTime = 60 * 60 * parseInt(noOfHours) * 1000
  var updatedDate = new Date(_date.getTime() + additionalTime)

  var updatedDateMonth = parseInt(updatedDate.getMonth() + 1)
  var updatedDateMonthFormatted =
    updatedDateMonth.toString().length === 1
      ? '0' + updatedDateMonth.toString()
      : updatedDateMonth

  var updateDateDay = updatedDate.getDate()
  var updatedDateDayFormatted =
    updateDateDay.toString().length === 1
      ? '0' + updateDateDay.toString()
      : updateDateDay

  var updateDateMinutes = updatedDate.getMinutes()
  var updateDateMinutesFormatted =
    updateDateMinutes.toString().length === 1
      ? '0' + updateDateMinutes.toString()
      : updateDateMinutes

  let hours =
    updatedDate.getHours() < 10
      ? '0' + updatedDate.getHours()
      : updatedDate.getHours()
  var formattedDate =
    updatedDate.getFullYear() +
    '-' +
    updatedDateMonthFormatted +
    '-' +
    updatedDateDayFormatted +
    'T' +
    hours +
    ':' +
    updateDateMinutesFormatted
  return formattedDate
}

export const formatDateToString = (
  date,
  separator,
  useShortMonth = false,
  includeHHNN = false,
  excludeYear = false
) => {
  if (date === null || date === undefined) {
    return null
  }
  var month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  let _date = new Date(date)
  let mon = month[_date.getMonth()]
  let hhnn = ''
  if (useShortMonth) mon = mon.substring(0, 3)
  if (includeHHNN) {
    hhnn = separator + _date.getHours() + ':'
    if (_date.getMinutes() < 10) hhnn += '0'
    hhnn += _date.getMinutes().toString()
  }
  return (
    _date.getDate() +
    separator +
    mon +
    (excludeYear ? '' : separator + _date.getFullYear()) +
    hhnn
  )
}

export const convertPerAnnumToFortnightly = (annualValue) => {
  if (annualValue && !isNaN(annualValue) && annualValue > 0) {
    return parseFloat(annualValue / 26)
  }

  return annualValue
}

export const payFrequencyToPaysPA = (payFrequency) => {
  if(payFrequency === 'Fortnightly')
    return 26
  if(payFrequency === 'Monthly')
    return 12

  return 0 //force divide by zero error to pick up any other frequencies
}

export const getQueryStringValueByParameter = (parameter, url) => {
  if (!url) url = window.location.href
  parameter = parameter.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + parameter + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

//IsSpecialEmployer, startswith is optional. Pass true for a x% match, don't pass for exact match
export const IsSpecialEmployer = (employerCode, startswith) => {
  let specialCode = useSelector(
    (state) =>
      state.user &&
      state.user.employer &&
      state.user.employer.specialEmployerCode
  )
  let productId = useSelector(
    (state) =>  
      state.individualEstimate && 
      state.individualEstimate.estimate && 
      state.individualEstimate.estimate.productId
  )
  
  if (employerCode ==='SAGBYO') { //Looking on any estimate for productId value of 'BYO Novated Lease'
    if(!productId) return false
    return (productId.toLowerCase().replace(/ /g, '') === 'byonovatedlease')
  }
  else //Non-SAG, look in employer specialEmployerCode
  { 
    if (!specialCode) return false
    if (startswith !== undefined)
      return specialCode.toLowerCase() === employerCode.toLowerCase()
    else return specialCode.toLowerCase().startsWith(employerCode.toLowerCase())
  }
}

export const IsVehicleElectric = (estimate, orHybrid) => {
  if (orHybrid)
    return (
      estimate &&
      estimate.vehicle &&
      estimate.vehicle.fuelType &&
      toLowerCase(estimate.vehicle.fuelType).includes('electric')
    )
  else
    return (
      estimate &&
      estimate.vehicle &&
      estimate.vehicle.fuelType &&
      toLowerCase(estimate.vehicle.fuelType) === 'electric'
    )
}

export const traceToAdobeAnalytics = (object) => {
  window.digitalData = object
}

export const fireViewEndCustomEvent = (id, object) => {
  var event = new CustomEvent('event-view-end', object)
  var obj = document.querySelector(id)
  obj.dispatchEvent(event)
}

export const fireViewStartCustomEvent = (object) => {
  var event = new CustomEvent('event-view-start', object)
  document.dispatchEvent(event)
}

export const fireInteractionCustomEvent = (object) => {
  var event = new CustomEvent('event-action-trigger', object)
  document.dispatchEvent(event)
}

export const checkConsultant = () => {
  return window.location.href.toLowerCase().indexOf('consultant') > -1
}

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0])
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return size
}

export const clearApplicationStorage = () => {
  document.cookie = ''
  localStorage.clear()
}

export const isUUID = (uuid) => {
  let s = '' + uuid

  s = s.match(
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$'
  )
  if (s === null) {
    return false
  }
  return true
}

export const formatDate = (inputDate) => {
  let date, month, year

  date = inputDate.getDate()
  month = inputDate.getMonth() + 1
  year = inputDate.getFullYear()

  date = date.toString().padStart(2, '0')

  month = month.toString().padStart(2, '0')

  return `${date}/${month}/${year}`
}
